import React from "react";
import { Progress } from "antd";

interface ProgressItem {
  percent: number;
  color: string;
  totalPercent?: number;
}

const ProgressBarRow: React.FC<{ progressData: ProgressItem[]; totalPercent }> =
  React.memo(({ progressData, totalPercent }) => {
    return (
      <div style={{ width: "100%", marginTop: 6 }}>
        <div style={{ display: "flex", width: "100%", position: "relative" }}>
          {progressData.map((item, index) => (
            <div
              className="custom-progressbar"
              key={index}
              style={{
                width: `${item.percent}`,
                position: "relative",
                zIndex: progressData.length - index,
              }}
            >
              <Progress
                percent={100}
                showInfo={false}
                strokeColor={item.color}
              />
            </div>
          ))}
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            marginTop: 8,
          }}
        >
          {progressData.map((item, index) => (
            <div
              key={index}
              style={{
                width: `${item.percent / 3}`,
                fontSize: 18,
                fontWeight: 600,
                color: item.color,
              }}
            >
              {item.percent}
            </div>
          ))}
        </div>
      </div>
    );
  });

export default ProgressBarRow;
